import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { VisualizarBoletoService } from './visualizar-boleto.service';

@Component({
  selector: 'app-visualizar-boleto',
  templateUrl: './visualizar-boleto.component.html',
  styleUrls: ['./visualizar-boleto.component.css']
})
export class VisualizarBoletoComponent implements OnInit, OnDestroy {

  @Input()
  public boleto: string = "";

  constructor(private visualizarBoletoService: VisualizarBoletoService) {
    this.boleto = visualizarBoletoService.arquivoBase64;
  }

  ngOnInit() {
    sessionStorage.removeItem('currentDeposit');
  }

  ngOnDestroy() {
    this.visualizarBoletoService.arquivoBase64 = "";
    this.boleto = "";
  }

}
